// TODO: 车机给的json菜单需要处理后才能使用云鹏的通用组件

import list from '@/static/main_config.json';
import l6ProList2024 from '@//static/l6_pro_config_2024.json';
import l6MaxList2024 from '@//static/l6_max_config_2024.json';
import l7AirList2023 from '@//static/l7_air_config_2023.json';
import l7MaxList2023 from '@//static/l7_max_config_2023.json';
import l7ProList2023 from '@//static/l7_pro_config_2023.json';
import l7ProList2024 from '@//static/l7_pro_config_2024.json';
import l7UltraList2024 from '@//static/l7_ultra_config_2024.json';
import l7MaxList2024 from '@//static/l7_max_config_2024.json';
import l8AirList2023 from '@//static/l8_air_config_2023.json';
import l8MaxList2022 from '@//static/l8_max_config_2022.json';
import l8ProList2022 from '@//static/l8_pro_config_2022.json';
import l8ProList2024 from '@//static/l8_pro_config_2024.json';
import l8UltraList2024 from '@//static/l8_ultra_config_2024.json';
import l8MaxList2024 from '@//static/l8_max_config_2024.json';
import l9MaxList2022 from '@//static/l9_max_config_2022.json';
import l9ProList2022 from '@//static/l9_pro_config_2022.json';
import l9UltraList2024 from '@//static/l9_ultra_config_2024.json';
import l9ProList2024 from '@//static/l9_pro_config_2024.json';
import megaUltraList2024 from '@//static/mega_ultra_config_2024.json';
import l6ProList2025 from '@//static/l6_pro_config_2025.json';
import l6MaxList2025 from '@//static/l6_max_config_2025.json';
import l7MaxList2025 from '@//static/l7_max_config_2025.json';
import l7ProList2025 from '@//static/l7_pro_config_2025.json';
import l7UltraList2025 from '@//static/l7_ultra_config_2025.json';
import l8MaxList2025 from '@//static/l8_max_config_2025.json';
import l8ProList2025 from '@//static/l8_pro_config_2025.json';
import l8UltraList2025 from '@//static/l8_ultra_config_2025.json';
import l9UltraList2025 from '@//static/l9_ultra_config_2025.json';
import l9ProList2025 from '@//static/l9_pro_config_2025.json';
import megaUltraList2025 from '@//static/mega_ultra_config_2025.json';
import megaHomeList2025 from '@//static/mega_home_config_2025.json';

function init(carType: Array<any>) {
    let str = JSON.stringify(carType);
    str = str.replace(/(firstMenuName)/g, 'title');
    str = str.replace(
        /(firstMenuName|secondMenuName|thirdMenuName|fourthMenuName)/g,
        'title'
    );
    str = str.replace(/(firstMenuId|secondMenuId|thirdMenuId)/g, 'id');
    str = str.replace(
        /(secondMenuList|thirdMenuList|fourthMenuList)/g,
        'children'
    );
    str = str.replace(/(imageName|secondMenuName)/g, 'imgUrl');
    str = str.replace(/(fileName)/g, 'url');

    interface IOption {
        childNodeStatus: number;
        id: number;
        midsParentStructureCode: string;
        midsStructureCode: string;
        structureName: string;
        structureLevel?: number;
        url?: string;
        vehicleModel?: number;
    }

    const urlInit = (url: string) => {
        if (!url) {
            return '';
        }
        // one视频处理
        if (url.indexOf('carhelp.lixiang.com') > -1) {
            return url;
        }
        if (url.indexOf('http') > -1) {
            const s = url.split('.lixiang.com/');
            if (s.length > 1 && s[1]) {
                return s[1];
            }
        }
        return url;
    };

    const nlist = JSON.parse(str);

    const arr: IOption[] = [];
    const ioption: IOption = {
        childNodeStatus: 1,
        id: 1,
        midsParentStructureCode: 'CHJ',
        midsStructureCode: 'CHJI',
        structureName: ''
    };
    arr.push(ioption);
    nlist.forEach(
        (aitem: { id: any; title: any; children: any[] }, aindex: any) => {
            const aoption: IOption = {
                childNodeStatus: 1,
                id: aitem.id,
                midsParentStructureCode: 'CHJI',
                midsStructureCode: `CHJA${aindex}`,
                structureLevel: 20,
                structureName: aitem.title
            };
            if (aitem.children && aitem.children.length) {
                arr.push(aoption);
                aitem.children.forEach((bitem, bindex) => {
                    const boption: IOption = {
                        childNodeStatus: 1,
                        id: bitem.id,
                        midsParentStructureCode: `CHJA${aindex}`,
                        midsStructureCode: `CHJB${aindex}${bindex}`,
                        structureLevel: 20,
                        structureName: bitem.title
                    };
                    arr.push(boption);
                    if (bitem.children && bitem.children.length) {
                        bitem.children.forEach(
                            (
                                citem: {
                                    title: any;
                                    url: any;
                                    proUrl: any;
                                    vehicleModel: any;
                                    children: any;
                                    id: any;
                                },
                                cindex: any
                            ) => {
                                const {
                                    title,
                                    url,
                                    proUrl,
                                    vehicleModel,
                                    children,
                                    id
                                } = citem;

                                if (!children) {
                                    const coption: IOption = {
                                        childNodeStatus: 0,
                                        id: bitem.id,
                                        midsParentStructureCode: `CHJB${aindex}${bindex}`,
                                        midsStructureCode: `CHJC${cindex}`,
                                        structureLevel: 20,
                                        structureName: title,
                                        url: urlInit(url || proUrl),
                                        vehicleModel
                                    };
                                    arr.push(coption);
                                } else {
                                    const coptions: IOption = {
                                        childNodeStatus: 1,
                                        id,
                                        midsParentStructureCode: `CHJB${aindex}${bindex}`,
                                        midsStructureCode: `CHJC${aindex}${bindex}${cindex}`,
                                        structureLevel: 20,
                                        structureName: title
                                    };
                                    arr.push(coptions);
                                    children.forEach(
                                        (
                                            ditem: {
                                                title: any;
                                                url: any;
                                                proUrl: any;
                                                vehicleModel: any;
                                            },
                                            dindex: any
                                        ) => {
                                            const {
                                                title: l9title,
                                                url: l9url,
                                                proUrl: fourproUrl,
                                                vehicleModel: fourvehicleModel
                                            } = ditem;

                                            const doption: IOption = {
                                                childNodeStatus: 0,
                                                id: citem.id,
                                                midsParentStructureCode: `CHJC${aindex}${bindex}${cindex}`,
                                                midsStructureCode: `CHJD${dindex}`,
                                                structureLevel: 20,
                                                structureName: l9title,
                                                url: urlInit(
                                                    l9url || fourproUrl
                                                ),
                                                vehicleModel: fourvehicleModel
                                            };

                                            arr.push(doption);
                                        }
                                    );
                                }
                            }
                        );
                    }
                });
            }
        }
    );
    return arr;
}
const m10 = init(list);
const l6Pro2024 = init(l6ProList2024);
const l6Max2024 = init(l6MaxList2024);
const l7Air2023 = init(l7AirList2023);
const l7Max2023 = init(l7MaxList2023);
const l7Pro2023 = init(l7ProList2023);
const l7Pro2024 = init(l7ProList2024);
const l7Ultra2024 = init(l7UltraList2024);
const l7Max2024 = init(l7MaxList2024);
const l8Air2023 = init(l8AirList2023);
const l8Max2022 = init(l8MaxList2022);
const l8Pro2022 = init(l8ProList2022);
const l8Pro2024 = init(l8ProList2024);
const l8Ultra2024 = init(l8UltraList2024);
const l8Max2024 = init(l8MaxList2024);
const l9Max2022 = init(l9MaxList2022);
const l9Pro2022 = init(l9ProList2022);
const l9Ultra2024 = init(l9UltraList2024);
const l9Pro2024 = init(l9ProList2024);
const megaUltra2024 = init(megaUltraList2024);
const l6Pro2025 = init(l6ProList2025);
const l6Max2025 = init(l6MaxList2025);
const l7Max2025 = init(l7MaxList2025);
const l7Pro2025 = init(l7ProList2025);
const l7Ultra2025 = init(l7UltraList2025);
const l8Max2025 = init(l8MaxList2025);
const l8Pro2025 = init(l8ProList2025);
const l8Ultra2025 = init(l8UltraList2025);
const l9Pro2025 = init(l9ProList2025);
const l9Ultra2025 = init(l9UltraList2025);
const megaUltra2025 = init(megaUltraList2025);
const megaHome2025 = init(megaHomeList2025);

export {
    megaHome2025,
    megaUltra2025,
    l9Ultra2025,
    l9Pro2025,
    l8Ultra2025,
    l8Pro2025,
    l8Max2025,
    l7Ultra2025,
    l7Pro2025,
    l7Max2025,
    l6Max2025,
    l6Pro2025,
    m10,
    l6Pro2024,
    l6Max2024,
    l7Air2023,
    l7Max2023,
    l7Pro2023,
    l7Pro2024,
    l7Ultra2024,
    l7Max2024,
    l8Air2023,
    l8Max2022,
    l8Pro2022,
    l8Pro2024,
    l8Ultra2024,
    l8Max2024,
    l9Max2022,
    l9Pro2022,
    l9Ultra2024,
    l9Pro2024,
    megaUltra2024
};
